// interceptors/auth.interceptor.ts
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, switchMap, throwError, BehaviorSubject, filter, take } from 'rxjs';

let isRefreshing = false;
let refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  
  let authReq = req;
  
  const payload = JSON.parse(req.body);
  if (token && !isPublicEndpoint(payload.accion)) {
    authReq = addTokenToRequest(req, token);
  }
  
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const payload = JSON.parse(req.body);
      if (error.status === 401 && !isPublicEndpoint(payload.accion)) {
        // return handle401Error(authReq, next, authService);
        console.log('401');
      }
      return throwError(() => error);
    })
  );
};

function addTokenToRequest(req: HttpRequest<any>, token: string): HttpRequest<any> {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  });
}

function isPublicEndpoint(action: string): boolean {
  const publicEndpoints = [
    'loginJSON', 
    'send_password_recovery_mail',
    'read_by_dni_and_num_olegiado',
    'existeUsuarioPorNombre',
    'registrarUsuario',
    'refresh'];
  return publicEndpoints.some(endpoint => action === endpoint);
}

function handle401Error(req: HttpRequest<any>, next: HttpHandlerFn, authService: AuthService) {
  if (!isRefreshing) {
    isRefreshing = true;
    refreshTokenSubject.next(null);
    
    return authService.refreshToken().pipe(
      switchMap((response: any) => {
        isRefreshing = false;
        refreshTokenSubject.next(response.token);
        const newReq = addTokenToRequest(req, response.token);
        return next(newReq);
      }),
      catchError((error) => {
        isRefreshing = false;
        authService.logout();
        return throwError(() => error);
      })
    );
  } else {
    return refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(token => next(addTokenToRequest(req, token!)))
    );
  }
}
